import { Alert } from 'components/FbUI/Alert'
import type { Campaign } from 'models/campaign'

interface MissingContactsBannerProps {
  campaign: Campaign
  className?: string
}

/**
 * Surface targets that have zero contacts so the user can fix or remove them
 * before launch. Shows nothing when every target has at least one contact.
 */
export function MissingContactsBanner({
  campaign,
  className,
}: MissingContactsBannerProps) {
  const total = campaign.contact_company_count
  const withContacts = campaign.companies_with_contacts
  const missing = Math.max(0, total - withContacts)

  if (total === 0 || missing === 0) return null

  return (
    <Alert
      color="warning"
      className={className}
      title={`${missing} of ${total} ${total === 1 ? 'target' : 'targets'} ${
        missing === 1 ? 'has' : 'have'
      } no contacts yet`}
      description="Filter the table by Contacts = 0 to review, then request contacts or remove the company before launch."
    />
  )
}
